<template>
  <div>
    <slot :errors="errors" />
  </div>
</template>

<script>
export default {
  name: 'BaseFormField',

  props: {
    value: { type: [String, Number, Object, Array], default: '' },
    rules: { type: Array, default: () => [] }
  },

  data: () => ({
    errors: []
  }),

  watch: {
    value: {
      handler: 'defineIsValid'
    }
  },

  methods: {
    defineIsValid() {
      this.errors = this.rules
        .map(rule => rule(this.value))
        .filter(v => typeof v === 'string')

      return !this.errors.length
    }
  }
}
</script>
